module.exports = __webpack_public_path__ + "static/media/ic_download.f4f46e7f.svg";